/**
 * @file index.tsx
 * @deprecated Copied to app/modules/procurement/pages/po-management/index.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/po-management/index
 * @description Router container for Purchase Order Management module. Defines routes
 *   for PO list, create, edit, and details views. Manages navigation between sub-pages
 *   and maintains page title/breadcrumb context using uTrade layout components.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 *
 * @todo [P3] Fix breadcrumb route path: use /UProcure/purchase-order-management to match
 *   registered private route and prevent broken breadcrumb navigation.
 * @todo [P3] Remove unused Navigate import from react-router-dom to avoid lint noise.
 * @todo [P1] Route parity with uprocure: decide whether to expose a PO-level
 *   receive-goods route (or alias redirect) for migration compatibility with
 *   /purchase-order-management/receive-goods deep links used by older flows.
 */

import { Outlet, Route, Routes } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../../_admin/layout/core';
import AddPurchaseOrder from './add-purchase-order';
import EditPurchaseOrder from './edit-purchase-order';
import PurchaseOrderDetails from './purchase-order-details';
import './_style.css';
import PurchaseOrderList from './purchase-order-list';
import DraftPoDetails from './draft-po-details';
const purchaseOrderBreadCrumbs: Array<PageLink> = [
  {
    title: 'UProcure',
    path: '/UProcure',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const purchaseOrderv2BreadCrumbs: Array<PageLink> = [
  {
    title: 'UProcure',
    path: '/UProcure',
    isSeparator: false,
    isActive: false,
  },
  {
    title: 'Purchase Orders',
    path: '/purchase-order-management',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const PurchaseOrderManagementPage = () => (
  <Routes>
    <Route element={<Outlet />}>
      <Route
        index
        element={
          <>
            <PageTitle breadcrumbs={purchaseOrderBreadCrumbs}>
              Purchase Orders
            </PageTitle>
            <PurchaseOrderList />
          </>
        }
      />
      <Route
        path="add-purchase-order"
        element={
          <>
            <PageTitle breadcrumbs={purchaseOrderv2BreadCrumbs}>
              Add Purchase Order
            </PageTitle>
            <AddPurchaseOrder />
          </>
        }
      />
      <Route
        path="edit-purchase-order"
        element={
          <>
            <PageTitle breadcrumbs={purchaseOrderv2BreadCrumbs}>
              Edit Purchase Order
            </PageTitle>
            <EditPurchaseOrder />
          </>
        }
      />
      <Route
        path="draft-purchase-order-details"
        element={
          <>
            <PageTitle breadcrumbs={purchaseOrderv2BreadCrumbs}>
              Draft PO Details
            </PageTitle>
            <DraftPoDetails />
          </>
        }
      />
      <Route
        path="purchase-order-details"
        element={
          <>
            <PageTitle breadcrumbs={purchaseOrderv2BreadCrumbs}>
              Purchase Order Details
            </PageTitle>
            <PurchaseOrderDetails />
          </>
        }
      />
    </Route>
  </Routes>
);
export default PurchaseOrderManagementPage;
